<template>
  <div class="renwu">
    <!-- 定制项目列表 项目推荐 -->
    <div class="top">
      <Select
        class="select"
        v-model="naireId"
        placeholder="问卷"
        clearable
        @on-clear="peopleChange"
        @on-change="peopleChange"
      >
        <Option
          v-for="(item, index) in juanList"
          :value="item.naireId + ''"
          :key="index"
          >{{ item.naireNameText }}</Option
        >
      </Select>
      <Select
        class="select"
        v-model="questionId"
        placeholder="问题"
        clearable
        @on-clear="tiChange"
        @on-change="tiChange"
      >
        <Option
          v-for="(item, index) in tiList"
          :value="item.questionId + ''"
          :key="index"
          >{{ item.questionNameText }}</Option
        >
      </Select>
      <Select
        class="select"
        v-model="optionsId"
        placeholder="选项"
        clearable
        @on-clear="xiangChange"
        @on-change="xiangChange"
      >
        <Option
          v-for="(item, index) in xiangList"
          :value="item.optionsId + ''"
          :key="index"
          >{{ item.optionsNameText }}</Option
        >
      </Select>
      <Select
        class="select"
        v-model="departId"
        placeholder="推荐科室"
        clearable
        @on-clear="keChange"
        @on-change="keChange"
      >
        <Option
          v-for="(item, index) in keList"
          :value="item.departId + ''"
          :key="index"
          >{{ item.departName }}</Option
        >
      </Select>
      <Select
        class="select"
        v-model="examId"
        placeholder="推荐项目"
        clearable
        @on-clear="tuiChange"
        @on-change="tuiChange"
      >
        <Option
          v-for="(item, index) in tuiangList"
          :value="item.examId + ''"
          :key="index"
          >{{ item.examName }}</Option
        >
      </Select>
      <Select
        class="select"
        v-model="accordId"
        placeholder="推荐依据"
        clearable
        @on-clear="yiChange"
        @on-change="yiChange"
      >
        <Option
          v-for="(item, index) in yiList"
          :value="item.accordId + ''"
          :key="index"
          >{{ item.accordName }}</Option
        >
      </Select>
      <Select
        class="select"
        v-model="adviseLevel"
        placeholder="推荐等级"
        clearable
        @on-clear="dengChange"
        @on-change="dengChange"
      >
        <Option value="">全部</Option>
        <Option value="1">一级</Option>
        <Option value="2">二级</Option>
        <Option value="3">三级</Option>
      </Select>
      <Button class="btn fourSize" type="success" @click="addItem" ghost
        >新增</Button
      >
    </div>
    <div class="table-cont">
      <Table
        @on-sort-change="changesort"
        stripe
        @on-selection-change="selectChange"
        :columns="columns"
        :data="data"
      ></Table>
    </div>
    <div class="page-div">
      <div class="page-div-left">
        已选 <span>{{ selectNum }}</span> 条
      </div>
      <Page
        @on-page-size-change="changepeoplepage"
        @on-change="changePeoplecurrent"
        :total="obj.count"
        show-elevator
        show-total
        :current="current"
        :page-size="pageSize"
        show-sizer
        class="page-div-page"
      />
    </div>

    <!-- 新增 修改弹框 -->
    <Modal
      class="ivumodal"
      footer-hide
      width="700"
      v-model="modify"
      :title="title"
    >
      <div class="modal-cont">
        <Form
          ref="xiugai"
          :model="xiugai"
          :rules="xiugaidata"
          :label-width="150"
        >
          <FormItem
            label="问卷名称："
            v-show="title == '新增'"
            prop="naireId"
            class="bumenModal-item"
          >
            <Select
              class="select"
              v-model="xiugai.naireId"
              placeholder="问卷名称"
              :label-in-value="true"
              clearable
              @on-clear="peopleChange('a')"
              @on-change="peopleChange('a')"
              style="width:300px;"
            >
              <Option
                v-for="(item, index) in juanList2"
                :value="item.naireId + ''"
                :key="index"
                >{{ item.naireNameText }}</Option
              >
            </Select>
          </FormItem>
          <FormItem
            label="问题名称："
            v-show="title == '新增'"
            prop="questionId"
            class="bumenModal-item"
          >
            <Select
              class="select"
              v-model="xiugai.questionId"
              placeholder="请先选择问卷再选择问题名称"
              :label-in-value="true"
              clearable
              @on-clear="tiChange('a')"
              @on-change="tiChange('a')"
              style="width:300px;"
            >
              <Option
                v-for="(item, index) in tiList2"
                :value="item.questionId + ''"
                :key="index"
                >{{ item.questionNameText }}</Option
              >
            </Select>
          </FormItem>
          <FormItem
            label="选项："
            v-show="title == '新增'"
            prop="optionsId"
            class="bumenModal-item"
          >
            <Select
              class="select"
              v-model="xiugai.optionsId"
              placeholder="请先选择问题再选择选项"
              clearable
              @on-clear="xiangChange('a')"
              @on-change="xiangChange('a')"
              style="width:300px;"
            >
              <Option
                v-for="(item, index) in xiangList2"
                :value="item.optionsId + ''"
                :key="index"
                >{{ item.optionsNameText }}</Option
              >
            </Select>
          </FormItem>

          <FormItem
            label="推荐科室："
            v-show="title == '新增'"
            prop="departId"
            class="bumenModal-item"
          >
            <Select
              class="select"
              v-model="xiugai.departId"
              placeholder="推荐科室"
              :label-in-value="true"
              clearable
              @on-clear="keChange2"
              @on-change="keChange2"
              style="width:300px;"
            >
              <Option
                v-for="(item, index) in keList2"
                :value="item.departId + ''"
                :key="index"
                >{{ item.departName }}</Option
              >
            </Select>
          </FormItem>
          <FormItem
            label="推荐项目："
            v-show="title == '新增'"
            prop="examId"
            class="bumenModal-item"
          >
            <Select
              class="select"
              v-model="xiugai.examId"
              placeholder="请先选择科室再选择推荐项目"
              :label-in-value="true"
              clearable
              @on-clear="tuiChange2"
              @on-change="tuiChange2"
              style="width:300px;"
            >
              <Option
                v-for="(item, index) in tuiangList2"
                :value="item.examId + ''"
                :key="index"
                >{{ item.examName }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="推荐依据：" prop="accordId" class="bumenModal-item">
            <Select
              class="select"
              v-model="xiugai.accordId"
              placeholder="推荐依据"
              clearable
              @on-clear="yiChange('a')"
              @on-change="yiChange('a')"
              style="width:300px;"
            >
              <Option
                v-for="(item, index) in yiList2"
                :value="item.accordId + ''"
                :key="index"
                >{{ item.accordName }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="展示顺序：" prop="showOrder" class="bumenModal-item">
            <Input
              v-model="xiugai.showOrder"
              type="number"
              placeholder="请输入数字0-2000展示顺序"
              style="color:#7F7F7F;width:300px;"
            />
          </FormItem>
          <FormItem
            label="推荐等级："
            prop="adviseLevel"
            class="bumenModal-item"
          >
            <RadioGroup v-model="xiugai.adviseLevel">
              <Radio label="1">
                <span>一级</span>
              </Radio>
              <Radio label="2" style="margin-left:50px;">
                <span>二级</span>
              </Radio>
              <Radio label="3" style="margin-left:50px;">
                <span>三级</span>
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="可用状态：" prop="invisible" class="bumenModal-item">
            <RadioGroup v-model="xiugai.invisible">
              <Radio label="0">
                <span>启用</span>
              </Radio>
              <Radio label="1" style="margin-left:50px;">
                <span>停用</span>
              </Radio>
            </RadioGroup>
          </FormItem>
        </Form>
        <div class="table-cont" v-show="title == '新增'">
          <Table stripe :columns="yicolumns" :data="data2"></Table>
        </div>
        <div
          class="page-div"
          style="margin-top:10px;text-align:right;"
          v-show="title == '新增'"
        >
          <Page
            @on-change="changePeoplecurrent2"
            :page-size-opts="[5]"
            :total="obj2.count"
            show-elevator
            show-total
            :current="current2"
            :page-size="5"
            show-sizer
            class="page-div-page"
          />
        </div>
        <div class="secondBumen-bottom">
          <Button class="btn" type="success" ghost @click="clear(1)"
            >取消</Button
          >
          <Button
            class="btn sure"
            type="success"
            ghost
            @click="clear(2, 'xiugai')"
            >确定</Button
          >
        </div>
      </div>
    </Modal>

    <!-- 删除弹框 -->
    <Modal class="ivumodal" v-model="sliceIBumen" title="删除" footer-hide>
      <div class="ivumodal-cont">
        删除后数据无法恢复，确认需要执行删除操作？
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="sliceIBumencancel"
          >取消</Button
        >
        <Button
          class="btn sure"
          type="success"
          ghost
          @click="sliceIBumencancel(1)"
          >确定</Button
        >
      </div>
    </Modal>

    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success"
      >操作成功</Alert
    >
    <Alert
      class="alertTitle"
      v-show="alertTitleIshow2"
      type="error"
      show-icon
      >{{ alertTitle }}</Alert
    >

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
  </div>
</template>
<script>
    import {
        formatMoney,
        selectStatementRecordList,
        backNaire,
        postbackNaire,
        updateNaire,
        deleteNaire,
        backQuestion,
        backOptions,
        getDepartItem,
        getDepart,
        accord,
        backAdvise,
        getbackAdvise,
        deleteAdvise,
        updateAdvise
    } from "../servers/api";
    export default {
        name: "jiesuan",
        data() {
            return {
                isiconfontshow: false,
                alertTitleIshow: false,
                alertTitleIshow2: false,
                alertTitle: "",
                sliceIBumen: false,
                selectNum: 0,
                selectList: [],
                xiugai: {
                    adviseLevel: "1",
                    invisible: "0",
                    departName: "",
                    examName: "",
                    questionId: "",
                    naireId: "",
                    optionsId: "",
                    departId: "",
                    examId: "",
                    accordId: "",
                    showOrder: ""
                },
                modify: false,
                xiugaidata: {
                    accordId: [{
                        required: true,
                        message: "请选择推荐依据",
                        trigger: "change",
                        Number
                    }],
                    naireId: [{
                        required: true,
                        message: "请选择问卷",
                        trigger: "change",
                        Number
                    }],
                    questionId: [{
                        required: true,
                        message: "请选择问题",
                        trigger: "change",
                        Number
                    }],
                    optionsId: [{
                        required: true,
                        message: "请选择选项",
                        trigger: "change",
                        Number
                    }],
                    departId: [{
                        required: true,
                        message: "请选择推荐科室",
                        trigger: "change",
                        Number
                    }],
                    examId: [{
                        required: true,
                        message: "请选择推荐检查项目",
                        trigger: "change",
                        Number
                    }],
                    adviseLevel: [{
                        required: true,
                        message: "请选择推荐等级",
                        trigger: "change",
                        Number
                    }],
                    naireId: [{
                        required: true,
                        message: "请选择推荐依据",
                        trigger: "change",
                        Number
                    }],
                    invisible: [{
                        required: true,
                        message: "请选择可用状态",
                        trigger: "change",
                        Number
                    }],
                    showOrder: [{
                        required: true,
                        message: "请请输入展示顺序",
                        trigger: "blur"
                    }]
                },
                data: [],
                data2: [],
                name: "可预约",
                background: "#fff",
                columns: [{
                    type: "selection",
                    width: 50,
                    align: "center"
                }, {
                    title: "问卷名称",
                    width: 220,
                    align: "center",
                    key: "naireNameText",
                    ellipsis: true,
                    sortable: true
                }, {
                    title: "问题名称",
                    width: 250,
                    align: "center",
                    key: "questionNameText",
                    ellipsis: true,
                    sortable: true
                }, {
                    title: "选项名称",
                    width: 250,
                    align: "center",
                    key: "optionsNameText",
                    ellipsis: true,
                    sortable: true
                }, {
                    title: "推荐科室",
                    width: 250,
                    align: "center",
                    key: "departName",
                    ellipsis: true,
                    sortable: true
                }, {
                    title: "推荐项目",
                    width: 250,
                    align: "center",
                    key: "examName",
                    ellipsis: true,
                    sortable: true
                }, {
                    title: "状态",
                    width: 110,
                    align: "center",
                    key: "invisible",
                    ellipsis: true,
                    sortable: true,
                    render: (h, params) => {
                        let a = "";
                        if (params.row.invisible == "0") {
                            a = "启用";
                        } else {
                            a = "停用";
                        }
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        height: "25px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        "line-height": "30px",
                                        color: "#7F7F7F"
                                    }
                                },
                                a
                            )
                        ]);
                    }
                }, {
                    title: "推荐等级",
                    width: 110,
                    align: "center",
                    key: "adviseLevel",
                    ellipsis: true,
                    sortable: true
                }, {
                    title: "依据名称",
                    width: 250,
                    align: "center",
                    key: "accordName",
                    ellipsis: true,
                    sortable: true,
                    render: (h, params) => {
                        let a = "";
                        if (params.row.needAdvise) {
                            a = "是";
                        } else {
                            a = "否";
                        }
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        height: "25px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        "line-height": "30px",
                                        color: "#7F7F7F"
                                    }
                                },
                                a
                            )
                        ]);
                    }
                }, {
                    title: "操作/调整",
                    key: "awssd",
                    align: "center",
                    width: 150,
                    fixed: "right",
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "div", {
                                    style: {
                                        height: "27px",
                                        display: "inline-block",
                                        "line-height": "27px",
                                        "text-align": "center",
                                        "font-size": "13px",
                                        border: "1px solid #53CAC3",
                                        "border-radius": "5px",
                                        width: "50px",
                                        cursor: "pointer",
                                        disabled: false,
                                        color: "#7F7F7F",
                                        "margin-left": "2px"
                                    },
                                    on: {
                                        click: () => {
                                            this.clearItem(params.row);
                                        }
                                    }
                                },
                                "删除"
                            ),
                            h(
                                "div", {
                                    style: {
                                        width: "50px",
                                        height: "27px",
                                        "line-height": "27px",
                                        "text-align": "center",
                                        "font-size": "13px",
                                        background: "#fff",
                                        border: "1px solid #53CAC3",
                                        "border-radius": "5px",
                                        "margin-left": "2px",
                                        cursor: "pointer",
                                        display: "inline-block",
                                        color: "#7F7F7F"
                                    },
                                    on: {
                                        click: () => {
                                            this.chengeTable(params.row);
                                        }
                                    }
                                },
                                "修改"
                            )
                        ]);
                    }
                }],
                yicolumns: [{
                    title: "推荐检查项目",
                    align: "center",
                    key: "examName",
                    ellipsis: true,
                    width: 140,
                    sortable: true
                }, {
                    title: "推荐等级",
                    align: "center",
                    key: "adviseLevel",
                    ellipsis: true,
                    sortable: true
                }, {
                    title: "依据来源",
                    align: "center",
                    key: "accordName",
                    ellipsis: true,
                    sortable: true
                }, {
                    title: "状态",
                    align: "center",
                    key: "invisible",
                    ellipsis: true,
                    sortable: true,
                    render: (h, params) => {
                        let a = "";
                        if (params.row.invisible == "0") {
                            a = "启用";
                        } else {
                            a = "停用";
                        }
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        height: "25px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        "line-height": "30px",
                                        color: "#7F7F7F"
                                    }
                                },
                                a
                            )
                        ]);
                    }
                }, {
                    title: "操作/调整",
                    key: "awssd",
                    align: "center",
                    width: 140,
                    render: (h, params) => {
                        let names = "停用";
                        if (params.row.invisible == "1") {
                            names = "启用";
                        }
                        return h("div", [
                            h(
                                "div", {
                                    style: {
                                        height: "27px",
                                        display: "inline-block",
                                        "line-height": "27px",
                                        "text-align": "center",
                                        "font-size": "13px",
                                        border: "1px solid #53CAC3",
                                        "border-radius": "5px",
                                        width: "50px",
                                        cursor: "pointer",
                                        disabled: false,
                                        color: "#7F7F7F",
                                        "margin-left": "2px"
                                    },
                                    on: {
                                        click: () => {
                                            this.qiChange(params.row);
                                        }
                                    }
                                },
                                names
                            ),
                            h(
                                "div", {
                                    style: {
                                        width: "50px",
                                        height: "27px",
                                        "line-height": "27px",
                                        "text-align": "center",
                                        "font-size": "13px",
                                        background: "#fff",
                                        border: "1px solid #53CAC3",
                                        "border-radius": "5px",
                                        "margin-left": "2px",
                                        cursor: "pointer",
                                        display: "inline-block",
                                        color: "#7F7F7F"
                                    },
                                    on: {
                                        click: () => {
                                            this.types = "弹框";
                                            this.clearItem(params.row);
                                        }
                                    }
                                },
                                "删除"
                            )
                        ]);
                    }
                }],
                current: 1,
                pageSize: 20,
                obj: {},
                obj2: {},
                orderField: "",
                isAsc: "",
                receivedStartDate: "",
                receivedEndDate: "",
                orderField: "",
                isAsc: "",
                title: "新增",
                naireNameTextLike: "",
                clearnaireId: "",
                juanList: [],
                juanList2: [],
                naireId: "", //问卷id
                tiList: [],
                tiList2: [],
                questionId: "", //问题id
                xiangList: [],
                xiangList2: [],
                optionsId: "", //选项id
                keList: [],
                keList2: [],
                departId: "", //科室id
                tuiangList: [],
                tuiangList2: [],
                examId: "", //推荐项目id
                adviseLevel: "",
                yiList: [],
                yiList2: [],
                accordId: "", //推荐依据id
                current2: 1,
                types: ""
            };
        },
        created() {
            this.selectStatementRecordList();
            this.backNaire();
            this.getDepart();
            this.accord();
        },
        methods: {
            qiChange(params) {
                //弹框里面的启用停用

                let obj = JSON.parse(JSON.stringify(params));
                if (obj.invisible == 0) {
                    obj.invisible = 1;
                } else {
                    obj.invisible = 0;
                }
                updateAdvise(obj).then(res => {
                    //弹框里的修改列表
                    if (res.data.code == 10000) {
                        let params = {
                            optionsId: this.xiugai.optionsId,
                            page: this.current2,
                            limit: 5
                        };
                        this.tablesGet(params);
                    }
                });
            },
            accord(e) {
                //推荐依据接口
                accord({}).then(res => {
                    if (res.data.code == 10000) {
                        this.yiList = res.data.data.data || [];
                        this.yiList2 = res.data.data.data || [];
                    }
                });
            },
            yiChange(e) {
                //推荐依据selct
                if (e !== "a") {
                    //新增
                    this.selectStatementRecordList();
                }
            },
            dengChange() {
                //等级切换select
                if (this.adviseLevel) {
                    this.selectStatementRecordList();
                } else {
                    this.adviseLevel = "";
                    this.selectStatementRecordList();
                }
            },
            tuiChange(e) {
                //推荐项目select选择后
                if (e !== "a") {
                    //新增
                    this.selectStatementRecordList();
                }
            },
            tuiChange2(e) {
                //新增弹框里面选择检查项目名称后
                if (e && e.label) {
                    this.xiugai.examName = e.label;
                }
            },
            keChange2(e) {
                //新增弹框里面选择科室后
                if (e && e.label) {
                    this.xiugai.departName = e.label;
                    this.keChange("a");
                }
            },
            keChange(e) {
                //科室select选择完 获取项目列表
                getDepartItem({
                    departId: e == "a" ? this.xiugai.departId : this.departId
                }).then(res => {
                    if (res.data.code == 10000) {
                        if (e == "a") {
                            this.xiugai.examId = "";
                            this.tuiangList2 = res.data.data.data || [];
                        } else {
                            this.examId = "";
                            this.tuiangList = res.data.data.data || [];
                            this.selectStatementRecordList();
                        }
                    } else {
                        this.tuiangList = [];
                        this.tuiangList2 = [];
                    }
                });
            },
            getDepart() {
                //获取科室列表接口
                getDepart({}).then(res => {
                    if (res.data.code == 10000) {
                        this.keList = res.data.data.data || [];
                        this.keList2 = res.data.data.data || [];
                    } else {
                        this.keList = [];
                        this.keList2 = [];
                    }
                });
            },
            xiangChange(e) {
                //选项select选择后
                if (e !== "a") {
                    //新增
                    this.selectStatementRecordList();
                } else {
                    let params = {
                        optionsId: this.xiugai.optionsId,
                        page: this.current2,
                        limit: 5
                    };
                    if (this.xiugai.optionsId && this.xiugai.optionsId !== "") {
                        this.tablesGet(params);
                    }
                }
            },
            tablesGet(params) {
                //弹框里面列表
                getbackAdvise(params).then(res => {
                    if (res.data.code == 10000) {
                        this.isiconfontshow = false;
                        this.obj2 = res.data.data || {};
                        this.data2 = res.data.data.data || [];
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                        this.obj = {};
                        this.data = [];
                    }
                });
            },
            backNaire() {
                //获取问卷接口
                backNaire({}).then(res => {
                    if (res.data.code == 10000) {
                        this.juanList = res.data.data.naireList || [];
                        this.juanList2 = res.data.data.naireList || [];
                    } else {
                        this.juanList = [];
                    }
                });
            },
            tiChange(e) {
                //问题select选择后 请求项
                backOptions({
                    questionId: e == "a" ? this.xiugai.questionId : this.questionId
                }).then(res => {
                    if (res.data.code == 10000) {
                        if (e == "a") {
                            this.xiugai.optionsId = "";
                            this.xiangList2 = res.data.data || [];
                        } else {
                            this.xiangList = res.data.data || [];
                            this.optionsId = "";
                            this.selectStatementRecordList();
                        }
                    } else {
                        this.xiangList = [];
                        this.xiangList2 = [];
                    }
                });
            },
            peopleChange(e) {
                //问卷select选择后 请求问题
                backQuestion({
                    naireId: e == "a" ? this.xiugai.naireId : this.naireId,
                    qtype: "2"
                }).then(res => {
                    if (res.data.code == 10000) {
                        if (e == "a") {
                            this.xiugai.questionId = "";
                            this.xiugai.optionsId = "";
                            this.tiList2 = res.data.data || [];
                        } else {
                            this.questionId = "";
                            this.optionsId = "";
                            this.tiList = res.data.data || [];
                            this.selectStatementRecordList();
                        }
                    } else {
                        this.tiList = [];
                        this.tiList2 = [];
                    }
                });
            },
            clearItem(item) {
                this.sliceIBumen = true;
                this.clearnaireId = item.adviseId;
            },
            sliceIBumencancel(index) {
                //删除接口
                if (index == 1) {
                    deleteAdvise({
                        adviseId: this.clearnaireId
                    }).then(res => {
                        if (res.data.code == 10000) {
                            this.sliceIBumen = false;
                            if ((this.types = "弹框")) {
                                //在弹框里面删除的推荐
                                let params = {
                                    optionsId: this.xiugai.optionsId,
                                    page: this.current2,
                                    limit: 5
                                };
                                this.tablesGet(params);
                            } else {
                                this.selectStatementRecordList(1);
                            }
                            this.isiconfontshow = false;
                            this.alertTitleIshow = true;
                            setTimeout(() => {
                                this.alertTitleIshow = false;
                            }, 2000);
                        } else {
                            this.isiconfontshow = false;
                            this.alertTitle = res.data.msg;
                            this.alertTitleIshow2 = true;
                            setTimeout(() => {
                                this.alertTitleIshow2 = false;
                            }, 2000);
                            this.obj = {};
                            this.data = [];
                        }
                    });
                } else {
                    this.sliceIBumen = false;
                }
            },
            backAdvise() {
                //新增接口
                let that = this;
                that.isiconfontshow = true;
                backAdvise(this.xiugai).then(res => {
                    if (res.data.code == 10000) {
                        that.modify = false;
                        that.isiconfontshow = false;
                        that.alertTitleIshow = true;
                        setTimeout(() => {
                            that.alertTitleIshow = false;
                        }, 2000);
                        this.selectStatementRecordList();
                    } else {
                        that.modify = false;
                        that.isiconfontshow = false;
                        that.alertTitle = res.data.msg;
                        that.alertTitleIshow2 = true;
                        setTimeout(() => {
                            that.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            updateAdvise() {
                //修改接口
                let that = this;
                this.isiconfontshow = true;
                updateAdvise(this.xiugai).then(res => {
                    if (res.data.code == 10000) {
                        that.modify = false;
                        that.isiconfontshow = false;
                        that.alertTitleIshow = true;
                        setTimeout(() => {
                            that.alertTitleIshow = false;
                        }, 2000);
                        this.selectStatementRecordList();
                    } else {
                        that.modify = false;
                        that.isiconfontshow = false;
                        that.alertTitle = res.data.msg;
                        that.alertTitleIshow2 = true;
                        setTimeout(() => {
                            that.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            clear(index, name) {
                //确定
                if (index == 2) {
                    //确定
                    this.$refs[name].validate(valid => {
                        if (valid) {
                            if (this.xiugai.adviseId && this.xiugai.adviseId !== "") {
                                this.updateAdvise();
                            } else {
                                this.backAdvise();
                            }
                        }
                    });
                } else {
                    this.modify = false;
                }
            },
            postupdateNaire() {
                //修改
                updateNaire(this.xiugai).then(res => {
                    if (res.data.code == 10000) {
                        this.modify = false;
                        this.isiconfontshow = false;
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                        this.selectStatementRecordList(1);
                    }
                });
            },
            selectStatementRecordList(index) {
                //获取列表
                this.isiconfontshow = true;
                if (index) {
                    this.current = 1;
                }
                let params = {
                    naireId: this.naireId,
                    questionId: this.questionId,
                    invisible: this.invisible,
                    optionsId: this.optionsId,
                    departId: this.departId,
                    examId: this.examId,
                    adviseLevel: this.adviseLevel,
                    accordId: this.accordId,
                    page: this.current,
                    limit: this.pageSize,
                    orderField: this.orderField,
                    isAsc: this.isAsc,
                    invisible: this.invisible
                };
                getbackAdvise(params).then(res => {
                    if (res.data.code == 10000) {
                        this.isiconfontshow = false;
                        this.obj = res.data.data || {};
                        this.data = res.data.data.data || [];
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                        this.obj = {};
                        this.data = [];
                    }
                });
            },
            postbackNaires() {
                //新建
                this.isiconfontshow = true;
                postbackNaire(this.xiugai).then(res => {
                    if (res.data.code == 10000) {
                        this.modify = false;
                        this.isiconfontshow = false;
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                        this.selectStatementRecordList(1);
                    }
                });
            },
            chengeTable(item) {
                //修改
                this.xiugai = JSON.parse(JSON.stringify(item));
                this.title = "修改";
                let obj = JSON.parse(JSON.stringify(item));
                for (let i in obj) {
                    if (typeof obj[i] == "number") {
                        obj[i] = obj[i] + "";
                    }
                }
                this.xiugai = obj;
                this.modify = true;
            },
            addItem() {
                //新增
                this.title = "新增";
                this.modify = true;
                this.xiugai = {
                    adviseLevel: "1",
                    invisible: "0",
                    departName: "",
                    examName: "",
                    questionId: "",
                    naireId: "",
                    optionsId: "",
                    departId: "",
                    examId: "",
                    accordId: "",
                    showOrder: ""
                };
                this.data2 = [];
                this.$refs["xiugai"].resetFields();
            },
            handleMaxSize(file) {
                this.$Message.success("请上传不超过800K的图片");
            },
            selectChange(item) {
                //表格select选中
                this.selectList = item;
                this.selectNum = this.selectList.length;
            },
            changepeoplepage(num) {
                //换每页请求多少条
                this.pageSize = num;
                this.selectStatementRecordList(1);
            },
            changePeoplecurrent(num) {
                //换页
                this.current = num;
                this.selectStatementRecordList();
            },
            changePeoplecurrent2(num) {
                //换页
                this.current2 = num;
                let params = {
                    optionsId: this.xiugai.optionsId,
                    page: this.current2,
                    limit: 5
                };
                this.tablesGet(params);
            },
            changesort(item) {
                //排序
                this.orderField = item.key;
                this.isAsc = item.order;
                this.current = 1;
                if (item.order == "normal") {
                    this.isAsc = "";
                    this.orderField = "";
                }
                this.selectStatementRecordList(1);
            }
        }
    };
</script>
<style lang="scss" scoped="" type="text/css">
    @import "../css/conmmon.scss";
    @import "../font/iconfont.css";
    .ivu-form /deep/ {
        .ivu-form-item-error-tip {
            padding-top: 0 !important;
        }
    }
    
    .bumenModal-item {
        margin-top: 10px;
    }
    
    .ivumodal /deep/ {
        .ivu-modal {
            top: 70px !important;
        }
    }
    
    .modal-cont {
        width: 100%;
        max-height: 690px;
        overflow: hidden;
        overflow-y: visible;
        padding-bottom: 20px;
        padding-right: 20px;
    }
    
    .modal-img-cont {
        width: 100%;
        position: relative;
        border: 1px solid #53cac3;
        height: 120px;
        border-radius: 5px;
        margin-top: 10px;
    }
    
    .position {
        position: absolute;
        top: 5px;
        font-size: 25px;
        color: #53cac3;
        right: 5px;
        cursor: pointer;
    }
    
    .modal-img-cont-title {
        display: inline-block;
        height: 100%;
        width: 150px;
        line-height: 90px;
        vertical-align: top;
    }
    
    .modal-img-cont-img {
        display: inline-block;
        width: 150px;
        height: 105px;
        margin: 5px 15px;
    }
    
    .modal-num {
        width: 100%;
        text-align: right;
        color: #53cac3;
        line-height: 10px;
    }
    
    .modal-span {
        width: 178px;
        display: inline-block;
        line-height: 17px;
        vertical-align: middle;
    }
    
    .i-icon {
        font-size: 25px;
        font-weight: 700;
        line-height: 30px;
        vertical-align: middle;
        color: #53cac3;
        margin-left: 3px;
        cursor: pointer;
        display: inline-block;
    }
    
    .renwu {
        font-size: 13px;
        padding: 15px;
        width: 100%;
        height: 100%;
        overflow: hidden;
        overflow-y: scroll;
        overflow-y: visible;
        .btn {
            float: right;
        }
        .top {
            width: calc(100% - 250px);
            height: 60px;
            line-height: 35px;
            position: fixed;
            top: 111px;
            z-index: 99;
            background: #fff;
            padding-top: 17px;
            left: 220px;
            padding-left: 15px;
            padding-bottom: 15px;
        }
        .select {
            width: 150px;
            // margin-right: 15px;
        }
        .journal-input {
            width: 180px;
            vertical-align: top;
        }
        .data {
            width: 190px;
            vertical-align: top;
        }
        .table-cont {
            padding-top: 40px;
            margin: 40px 0 60px;
        }
        .page-div {
            width: 100%;
            margin-top: 15px;
            position: fixed;
            background: #fff;
            width: calc(100% - 270px);
            height: 60px;
            z-index: 99;
            bottom: 0;
            padding-top: 15px;
            .page-div-left {
                float: left;
            }
            .page-div-page {
                float: right;
                margin-right: 15px;
            }
        }
        .title-btn {
            vertical-align: top;
            float: right;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/questions/dingzhi.vue